import { RoutePath } from 'enums/routePath';

const ROOT = '/activity-kpis';

const TEAM_ACTIVITY = `${ROOT}/team-activity`;
const USER_ACTIVITY = `${ROOT}/my-activity`;
const USER_ACTIVITY_ID = `${USER_ACTIVITY}/:userId`;

const paths = {
  [RoutePath.ACTIVITY_MAP]: ROOT,
  [RoutePath.TEAM_ACTIVITY]: TEAM_ACTIVITY,
  [RoutePath.USER_ACTIVITY]: USER_ACTIVITY,
  [RoutePath.USER_ACTIVITY_ID]: USER_ACTIVITY_ID,
};

export const pathArray = Object.values(paths);

export default paths;
